export const CONTRACT_STATUSES = {
  paper: "Non dématérialisé",
  unsigned: "Dématérialisé non signé",
  signed: "Signé",
  nonLieu: "Non-lieu",
  unknown: "Non renseigné",
};

// Use the document state for the relevant signatory, never the mission dates.
const flag = value => {
  if (value === true || value === 1 || /^(true|o|oui|1)$/i.test(String(value ?? "").trim())) return true;
  if (value === false || value === 0 || /^(false|n|non|0)$/i.test(String(value ?? "").trim())) return false;
  return null;
};
const dated = value => Boolean(value && !Number.isNaN(new Date(value).getTime()));
export function getContractStatus(contract = {}, audience = "candidate") {
  if (flag(contract.EstNonLieu) === true) return CONTRACT_STATUSES.nonLieu;
  const client = audience === "client";
  const signed = flag(client ? contract.signedByClient : contract.signedByUser);
  const signedDate = client ? contract.clientSignedDate : contract.userSignedDate;
  if (signed === true || dated(signedDate)) return CONTRACT_STATUSES.signed;
  const demat = flag(client ? contract.isDematClient : contract.isDematUser);
  const sent = client ? contract.DateEnvoiClientDemat : contract.DateEnvoiInterimaireDemat;
  const dematId = client ? contract.DematIdClient : contract.DematIdInterimaire;
  if (demat === true || dated(sent) || (dematId && String(dematId).trim() !== "0")) return CONTRACT_STATUSES.unsigned;
  const labels = {"non dematerialise":"paper", "dematerialise non signe":"unsigned", "signe":"signed"};
  for (const value of [contract.signatureStatus, contract.dematerializationStatus]) {
    const normalized = typeof value === "string" ? value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim() : "";
    if (labels[normalized]) return CONTRACT_STATUSES[labels[normalized]];
  }
  if (demat === false || flag(contract.isDemat) === false) return CONTRACT_STATUSES.paper;
  if (flag(contract.isDemat) === true) return CONTRACT_STATUSES.unsigned;
  return CONTRACT_STATUSES.unknown;
}
